import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const controller = this
    this.element.addEventListener('click', function () {
      controller.prevent_background_scroll()
      controller.contact_modal(
        this.dataset.contactModalName,
        this.dataset.contactModalTelNr,
        this.dataset.contactModalTelNrLink,
        this.dataset.contactModalEmail,
        this.dataset.contactModalEmailSubject,
        this.dataset.contactModalPositions,
      );
    });
  }

  getIcon(icon_name) {
    return `<div class="material-icons-outlined material-icons-outlined-colored">${icon_name}</div>`;
  }

  getCta(link, icon, call_title, css_class) {
    css_class = css_class || '';
    return `<div class="sl-masthead__button ${css_class}" style="display: flex;">
            <a href='${link}' class="slplaner-links-blue-color-text sl-button-wrapper noref">${icon}</a>
            <div style="margin-left: 0.5rem; font-size: 16px; margin-top: 2px"><a href='${link}'>${call_title}</a></div>
          </div>`;
  }

  getCallCta(nrlink, nr) {
    return this.getCta(nrlink, this.getIcon("call"), `${nr}`);
  }


  getEmailLink(email, subject) {
    if (typeof subject === 'undefined') {
      subject = 'Sl-Planer: Anfrage'
    }
    if (email === 'info@seabird.ch') {
      return `mailto:${email}?subject=${subject}`;
    }
    return `mailto:${email}?subject=${subject}&cc=info@seabird.ch`;
  }

  getMailCta(email, subject) {
    if (typeof email === 'undefined') {
      email = 'info@seabird.ch'
    }

    const link = this.getEmailLink(email, subject)
    const icon = this.getIcon("mail")

    return this.getCta(link, icon, email, "mt_16px");
  }

  contact_modal(name, nr, nrlink, email, subject, positions) {
    let elem = $("#landing-page-contact-modal");
    let append_element = elem.children(".modal-content").first();

    // empty modal element from previous content, if any
    $(append_element).empty();
    const call_link = this.getCallCta(nrlink, nr);
    const mail_link = this.getMailCta(email, subject);

    let content = `<div class="contact-name">${name}</div>`;

    if (typeof positions === "undefined") {
      content = `${content}
    <p class="company">
      Steinwiesstr. 8<br>
      8330 Pfäffikon ZH
    </p> 
    ${call_link} 
    ${mail_link}
    `
    } else {
      content = `${content} <p>${positions}</p> ${call_link} ${mail_link}`;
    }

    append_element.html(content);

    M.Modal.getInstance(elem).open();
  }

  prevent_background_scroll() {
    const header = document.querySelector("header");
    header.style.position = 'fixed'
    header.style.width = '100vw'

    const scrollY = parseInt($(window).scrollTop());
    document.body.style.position = 'fixed'
    document.body.style.paddingTop = `${header.offsetHeight}px`
    document.body.style.top = `-${scrollY}px`

    M.Modal.init(document.querySelectorAll('.modal'), {
      onCloseStart: () => this.enableScrolling(scrollY)
    })
  }

  enableScrolling(scrollY) {
    document.body.style.top = ''
    document.body.style.paddingTop = ''
    document.body.style.position = ''

    const header = document.querySelector("header");
    if (typeof header === 'object') {
      header.style.position = ''
      header.style.width = ''
    }

    $(window).scrollTop(scrollY)
  }
}